<div class="success-container">
    <div class="title">
        Success
    </div>
    <div class="content">
        Creative is uploaded successfully.
    </div>
</div>